import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../images/new_logo.png';

const Terms = () => {
  return (
    <div className="legal-page">
      <main className="legal-content">
        <div className="legal-container">
          <h1>Terms of Service</h1>
          <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>

          <section className="legal-section">
            <h2>1. Acceptance of Terms</h2>
            <p>By accessing and using BullBearly ("the Service"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.</p>
          </section>

          <section className="legal-section">
            <h2>2. Description of Service</h2>
            <p>BullBearly is a financial information aggregation and analysis platform that provides AI-powered insights from RSS feeds, social media sources, and other publicly available financial information. The Service is operated by BullBearly, LLC.</p>
          </section>

          <section className="legal-section">
            <h2>3. Financial Information Disclaimer</h2>
            <div className="disclaimer-box">
              <h3>⚠️ IMPORTANT FINANCIAL DISCLAIMER</h3>
              <p><strong>BullBearly is NOT a financial advisor, investment advisor, or securities dealer.</strong> All information provided by BullBearly is for informational and educational purposes only and should not be construed as investment advice, financial advice, trading advice, or any other sort of advice.</p>
              
              <p><strong>You should not make any investment decision without first consulting with a qualified investment advisor or conducting your own research and due diligence.</strong></p>
              
              <p>The information provided by BullBearly:</p>
              <ul>
                <li>Is not personalized financial advice</li>
                <li>Does not constitute a recommendation to buy, sell, or hold any security</li>
                <li>Is not intended to be a substitute for professional financial advice</li>
                <li>May not be suitable for your individual financial situation</li>
                <li>Should be verified independently before making any investment decisions</li>
              </ul>
              
              <p><strong>Past performance does not guarantee future results.</strong> All investments involve risk, including the potential loss of principal.</p>
            </div>
          </section>

          <section className="legal-section">
            <h2>4. No Investment Advice</h2>
            <p>BullBearly, LLC, its officers, directors, employees, agents, and affiliates do not:</p>
            <ul>
              <li>Provide personalized investment advice</li>
              <li>Make recommendations regarding specific securities</li>
              <li>Guarantee the accuracy, completeness, or timeliness of any information</li>
              <li>Assume any responsibility for investment decisions made based on our content</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>5. User Responsibilities</h2>
            <p>Users of BullBearly are solely responsible for:</p>
            <ul>
              <li>All investment decisions and their consequences</li>
              <li>Verifying the accuracy of any information before making investment decisions</li>
              <li>Consulting with qualified financial professionals when appropriate</li>
              <li>Compliance with all applicable securities laws and regulations</li>
              <li>Maintaining the security of their account credentials</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>6. Limitation of Liability</h2>
            <p>To the maximum extent permitted by law, BullBearly, LLC shall not be liable for any direct, indirect, incidental, special, consequential, or punitive damages, including but not limited to:</p>
            <ul>
              <li>Investment losses or financial damages</li>
              <li>Loss of profits, data, or business opportunities</li>
              <li>Damages resulting from reliance on our information</li>
              <li>Damages from third-party content or services</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>7. Third-Party Content</h2>
            <p>BullBearly aggregates content from various third-party sources including RSS feeds, social media platforms, and news websites. We do not control, endorse, or assume responsibility for the accuracy, completeness, or reliability of any third-party content.</p>
          </section>

          <section className="legal-section">
            <h2>8. AI and OpenAI Integration</h2>
            <p>BullBearly utilizes OpenAI's ChatGPT technology to analyze and summarize financial information. Users may provide their own OpenAI API key or use our provided API key. Users are responsible for:</p>
            <ul>
              <li>Compliance with OpenAI's Terms of Service when using their own API key</li>
              <li>Understanding the limitations and potential inaccuracies of AI-generated content</li>
              <li>Verifying AI-generated insights before making investment decisions</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>9. Privacy and Data Protection</h2>
            <p>Your privacy is important to us. Please review our Privacy Policy to understand how we collect, use, and protect your information.</p>
          </section>

          <section className="legal-section">
            <h2>10. Prohibited Uses</h2>
            <p>You may not use BullBearly for:</p>
            <ul>
              <li>Any unlawful purpose or to solicit others to perform unlawful acts</li>
              <li>Violating any international, federal, provincial, or state regulations, rules, laws, or local ordinances</li>
              <li>Transmitting or procuring the sending of any advertising or promotional material without our prior written consent</li>
              <li>Impersonating or attempting to impersonate BullBearly, a BullBearly employee, another user, or any other person or entity</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>11. Termination</h2>
            <p>We may terminate or suspend your account and bar access to the Service immediately, without prior notice or liability, under our sole discretion, for any reason whatsoever, including but not limited to a breach of the Terms.</p>
          </section>

          <section className="legal-section">
            <h2>12. Changes to Terms</h2>
            <p>We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will provide at least 30 days notice prior to any new terms taking effect.</p>
          </section>

          <section className="legal-section">
            <h2>13. Governing Law</h2>
            <p>These Terms shall be interpreted and governed by the laws of the United States and the state in which BullBearly, LLC is incorporated, without regard to its conflict of law provisions.</p>
          </section>

          <section className="legal-section">
            <h2>14. Contact Information</h2>
            <p>If you have any questions about these Terms of Service, please contact us at:</p>
            <p>
              BullBearly, LLC<br />
              Email: legal@bullbearly.com<br />
              Website: https://bullbearly.com
            </p>
          </section>

          <div className="legal-footer">
            <p><strong>By using BullBearly, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service.</strong></p>
          </div>
        </div>
      </main>

      <footer className="footer">
        <div className="footer-container">
          <div className="footer-content">
            <div className="footer-brand">
              <img src={logo} alt="BullBearly" className="footer-logo" />
              <span className="footer-brand-text">BullBearly</span>
            </div>
            <div className="footer-links">
              <Link to="/terms" className="footer-link">Terms of Service</Link>
              <Link to="/privacy" className="footer-link">Privacy Policy</Link>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2025 BullBearly, LLC. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Terms;
